export default "__VITE_ASSET__DUwHHMOp__"